interface IProps {
  when: boolean;
}

export const Exist: React.FC<IProps> = ({ children, when }): any => (when ? children : null);
